<!--
     Copyright (c) 2025-2026 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->

<clr-dropdown class="column-switch-wrapper">
    <button type="button"
            class="column-toggle--action btn btn-sm"
            [attr.aria-label]="'export.label' | vtranslate : [ariaLabel | vtranslate]"
            [title]="'export.label' | vtranslate : [ariaLabel | vtranslate]"
            [disabled]="exportInProgress"
            clrDropdownTrigger>
        {{'export' | vtranslate}}
        <cds-icon shape="angle" direction="down"></cds-icon>
    </button>
    <clr-dropdown-menu clrPosition="top-left">
        <button clrDropdownItem
                *ngIf="!serverDriven"
                [clrDisabled]="!serverDriven && allRowsCount === 0"
                (click)="export(0)">
            {{'export.allRows.count' | vtranslate: allRowsCount }}
        </button>
        <button clrDropdownItem
                *ngIf="serverDriven"
                (click)="export(0)">
            {{'export.allRows' | vtranslate }}
        </button>
        <button clrDropdownItem
                *ngIf="hasSelection"
                [clrDisabled]="selectedRowsCount === 0"
                (click)="export(1)">
            {{'export.selectedRows' | vtranslate: selectedRowsCount }}
        </button>
        <button clrDropdownItem
                *ngIf="hasFiltering"
                [clrDisabled]="filteredRowsCount === 0"
                (click)="export(2)">
            {{'export.matchingFilters' | vtranslate: filteredRowsCount }}
        </button>
    </clr-dropdown-menu>
</clr-dropdown>
